import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1f9ce724"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = ["href"]

import { ref } from 'vue'
import NotificationService from '@/services/NotificationService';
import { useAuth } from '@/store/useAuth';
import { useToast } from '@/store/useToast'
import { Toast } from '@/interfaces/ToastInterface';
import main from '@/data/main.js'


export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationDetail',
  props: ['title', 'content', 'id', 'resources'],
  emits: ['goBack'],
  setup(__props, { emit: __emit }) {

const notificationService = new NotificationService()
const notifications = ref([])
const store = useAuth()
const toast = useToast()

const props = __props;
const emit = __emit

const OnMarkAsRead = async () => {
    if(store.token  != null){
    await notificationService.MarkNotificationAsRead(store.token, props.id)
    notifications.value = await notificationService.ReadAllNotes(store.token)
    toast.showToast("Notificación leída.", Toast.SUCCESS)
    setTimeout(function () { toast.hideToast() }, 4000);}
}

const OnMarkAsUnread = async () => {
    if(store.token  != null){
    await notificationService.MarkNotificationAsUnread(store.token, props.id)
    notifications.value = await notificationService.ReadAllNotes(store.token)
    toast.showToast("Notificación marcada como no leída.", Toast.SUCCESS)
    setTimeout(function () { toast.hideToast() }, 4000);
    }
}

const OnGoBack = () => {
    emit('goBack')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "buttons" }, [
      _createElementVNode("button", { onClick: OnGoBack }, "Volver"),
      _createElementVNode("button", { onClick: OnMarkAsRead }, "Marcar como leído"),
      _createElementVNode("button", { onClick: OnMarkAsUnread }, "Marcar como NO leído")
    ]),
    _hoisted_2,
    _createElementVNode("h1", null, _toDisplayString(props.title), 1),
    _hoisted_3,
    _createElementVNode("div", {
      innerHTML: props.content,
      class: "notification-content"
    }, null, 8, _hoisted_4),
    _hoisted_5,
    _hoisted_6,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.resources, (elm) => {
      return (_openBlock(), _createElementBlock("a", {
        key: elm.id,
        href: `${_unref(main).FILES_CDN_READ}${elm.content_uri}`,
        target: "_blank"
      }, "Descargar Recurso", 8, _hoisted_7))
    }), 128))
  ]))
}
}

})